import elementBase from "../elementBase.js";

export default class DynamicKeyboard extends elementBase {
    objectType = "DynamicKeyboard";
    styleColor = '#553c9a'; // Violet foncé
    Background = '';
    UpBackground = '';
    DownBackground = '';
    Foreground = '';
    UpForeground = '';
    DownForeground = '';
    Radius = 0;
    FontSize = 0;
    ButtonMargin = 0;

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }
    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
        this.Background = args.background != null ? args.background : '';
        this.Foreground = args.foreground != null ? args.foreground : '';
        this.UpBackground = args.upBackground != null ? args.upBackground : '';
        this.DownBackground = args.downBackground != null ? args.downBackground : '';
        this.UpForeground = args.upForeground != null ? args.upForeground : '';
        this.DownForeground = args.downForeground != null ? args.downForeground : '';
        this.Radius = args.radius != null ? args.radius : 0;
        this.FontSize = args.fontSize != null ? args.fontSize : 0;
        this.ButtonMargin = args.buttonMargin != null ? args.buttonMargin : 0;
    }
    static get Name() {
        return "Clavier";
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Background", type: "colorInput", dataType: "string" },
            { name: "Foreground", type: "colorInput", dataType: "string" },
            { name: "UpBackground", type: "colorInput", dataType: "string" },
            { name: "DownBackground", type: "colorInput", dataType: "string" },
            { name: "UpForeground", type: "colorInput", dataType: "string" },
            { name: "DownForeground", type: "colorInput", dataType: "string" },
            { name: "Radius", type: "numberInput", dataType: "number" },
            { name: "FontSize", type: "numberInput", dataType: "number" },
            { name: "ButtonMargin", type: "numberInput", dataType: "number" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    getStyle(currentElementIndex = null) {
        let style = {
            ...super.getStyle(currentElementIndex),
            position: 'absolute',
        }
        return style;
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            background: this.hexColorValue(this.Background),
            foreground: this.hexColorValue(this.Foreground),
            upBackground: this.hexColorValue(this.UpBackground),
            downBackground: this.hexColorValue(this.DownBackground),
            upForeground: this.hexColorValue(this.UpForeground),
            downForeground: this.hexColorValue(this.DownForeground),
            radius: this.Radius,
            fontSize: this.FontSize,
            buttonMargin: this.ButtonMargin,
        };
    }
    toObject(minify = false) {
        let object = {
            ...super.toObject(minify),
            background: this.Background,
            foreground: this.Foreground,
            upBackground: this.UpBackground,
            downBackground: this.DownBackground,
            upForeground: this.UpForeground,
            downForeground: this.DownForeground,
            radius: this.Radius,
            fontSize: this.FontSize,
            buttonMargin: this.ButtonMargin,
        };
        return object;
    }
}
